// tslint:disable
export var AccountStatus;
(function (AccountStatus) {
    // UNKN
    AccountStatus[AccountStatus["UNKNOWN"] = 0] = "UNKNOWN";
    // ACT
    AccountStatus[AccountStatus["ACTIVE"] = 1] = "ACTIVE";
    // INACT
    AccountStatus[AccountStatus["INACTIVE"] = 2] = "INACTIVE";
})(AccountStatus || (AccountStatus = {}));
//# sourceMappingURL=AccountStatus.js.map